import React from 'react';
import {InputText} from "primereact/inputtext";

function InputDate({onFocus, value, onChange, label, className, autoFocus}) {
    return (
        <span className="p-float-label">
            <InputText value={value} autoFocus={autoFocus} onChange={onChange} readOnly onFocus={onFocus} className={className}/>
            <label>{label}</label>
        </span>
    )
}

export default InputDate;